import type { WorkspacePage } from "~/workspaces/state/workspace-page";

function getInitialWorkspacePage(pages: WorkspacePage[]) {
  if (!pages.length) {
    return undefined;
  }

  const activePage = pages.find((p) => p.active) ?? pages.at(0);

  if (!activePage?.href.length) {
    return undefined;
  }

  return activePage.href;
}

export { getInitialWorkspacePage };
